import { PSpinner } from '@porsche-design-system/components-react';

const LoadingSpinner = () => <PSpinner size="small" theme="light" />;

export default LoadingSpinner;
